import { TAppointment } from 'types/appointment';

export const getCardToken = (state: any): string =>
  state?.appointment?.stripe_token;

export const getAppointment = (state: any): TAppointment => state?.appointment;

export const getPersonalInfo = (state: { appointment: TAppointment }) => {
  const { firstName, lastName, phone, pronouns, email } = state.appointment;

  return { firstName, lastName, phone, pronouns, email };
};
